import { useContext, useEffect } from 'react';

import {
  ContextBarContext,
  ContextBarPageTransition,
} from 'src/context/contextBarContext';

/**
 * Hook for components to use the context bar.
 * @param transitionObj - The transition object to set the context bar to. If not provided, the context bar will not be transitioned.
 * @returns The context bar context value.
 */
export const useContextBar = (transitionObj?: ContextBarPageTransition) => {
  const contextBarContextValue = useContext(ContextBarContext);

  const { transition } = contextBarContextValue;
  const targetId = transitionObj?.target?.id;
  const targetEntityType = transitionObj?.target?.entityType;
  const open = transitionObj?.open;
  const drawerConfig = transitionObj?.drawerConfig;

  useEffect(() => {
    if (targetId && targetEntityType) {
      transition({
        target: { id: targetId, entityType: targetEntityType },
        drawerConfig,
        open,
      });
    }
  }, [targetId, targetEntityType, open, drawerConfig, transition]);

  return contextBarContextValue;
};
